module.exports = __webpack_public_path__ + "static/media/Rompers_thumb.87292a07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/moments-searching/Rompers_thumb.jpg
// module id = 204
// module chunks = 0